import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import ProductDetail from "../pages/product-detail/page";
import CartPage from "../pages/cart/page";
import AboutPage from "../pages/about/page";
import DurabilityPage from "../pages/durability/page";
import FAQPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";
import SearchPage from "../pages/search/page";
import WhyJoviaaPage from "../pages/why-joviaa/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import CookiePolicyPage from "../pages/cookie-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/product/:slug",
    element: <ProductDetail />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/durability",
    element: <DurabilityPage />,
  },
  {
    path: "/why-joviaa",
    element: <WhyJoviaaPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;